import React from 'react'
import Blue from '../sections/blue'
import { allIndustries } from '../../../jsons/allJsons'

const IndustrialEquipment = () => {
  return (
    <Blue data={allIndustries.industrialEquipment}/>
  )
}

export default IndustrialEquipment
